import { motion } from "framer-motion";
import { ArrowRight, Star } from "lucide-react";

export default function FoundingOffer({ onSchedule }) {
  return (
    <section id="founding-offer" className="py-24 md:py-32 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="relative grain overflow-hidden rounded-[2.5rem] md:rounded-[3rem] bg-plum text-cream p-8 md:p-16 lg:p-20">
          <div className="pointer-events-none absolute -top-24 -right-24 h-80 w-80 rounded-full bg-coral/20 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-marigold/15 blur-3xl" />

          <div className="relative grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7 }}
            >
              <span className="inline-block text-sm font-semibold tracking-[0.2em] uppercase text-marigold">
                Founding Community Offer
              </span>
              <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-cream/10 border border-cream/20 px-4 py-2">
                <span className="h-2 w-2 rounded-full bg-marigold animate-pulse" />
                <span className="text-sm font-semibold text-cream/90">Now welcoming three founding community partners</span>
              </div>

              <h2 className="mt-6 font-poppins font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                Become one of our founding partners.
              </h2>
              <p className="mt-6 text-lg md:text-xl leading-relaxed text-cream/75 max-w-lg">
                A limited founding-partner opportunity for the first three local senior communities
                to bring this experience to their residents and families.
              </p>

              <button
                data-testid="founding-schedule-btn"
                onClick={onSchedule}
                className="mt-9 group inline-flex items-center gap-2 rounded-full bg-coral text-cream font-semibold text-lg px-8 py-4 transition-all hover:-translate-y-1 hover:shadow-[0_24px_44px_-16px_rgba(240,125,106,0.6)]"
              >
                Request a 15-Minute Conversation
                <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
              </button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.12 }}
              className="rounded-[2rem] bg-cream text-charcoal p-8 md:p-10"
            >
              <span className="inline-flex items-center gap-1.5 rounded-full bg-marigold text-charcoal text-xs font-bold px-3 py-1.5">
                <Star size={13} fill="currentColor" /> Founding Partner
              </span>
              <h3 className="mt-5 font-poppins font-bold text-2xl md:text-3xl leading-snug">
                Resident &amp; Family Portrait Social
              </h3>

              <p className="mt-6 text-sm font-semibold uppercase tracking-wider text-charcoal/50">
                Founding Community Rate
              </p>
              <div className="mt-1 flex items-end gap-2">
                <span data-testid="founding-price" className="font-poppins font-extrabold text-6xl md:text-7xl text-coral">$750</span>
              </div>

              <div className="my-7 h-px bg-charcoal/10" />

              <p className="text-charcoal/75 leading-relaxed">
                Available to our first three local community partners.
                Future experiences begin at <span className="font-semibold text-charcoal">$1,200</span>.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
